var API_DOMAIN = "https://diwalichit.zentexus.in/zenchitbilling/api";
// var API_DOMAIN = "http://localhost/hemnath_chit_fund_backend/api";

export default API_DOMAIN;
